"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPermissionClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class EntityPermissionClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.basePath = '/v1/entity-permissions';
    }
    getAllowedEditors(projectId, entityType, entityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users/edit`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getAllowedEditorsByEntities(projectId, entityType, ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities-bulk/${entityType}/users/edit`;
            const response = yield this.httpPost(url, ids);
            return response.payload;
        });
    }
    auditPermissions(projectId, entityKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityKey.type}/${entityKey.id}/users`;
            const response = yield this.httpPost(url);
            return response.payload;
        });
    }
    auditManyEntitiesPermissions(projectId, entityType, entitiesIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.basePath}/projects/${projectId}/entities/${entityType}/users`;
            const response = yield this.httpPost(url, { entitiesIds });
            return response.payload;
        });
    }
    transfertOwnership(projectId, entityType, entityId, ownerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/owner`, { ownerId });
            return response.payload;
        });
    }
    grantEditPermission(projectId, entityType, entityId, assigneeIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users/edit`, {
                assigneeIds,
            });
        });
    }
    revokeEditPermission(projectId, entityType, entityId, revokeeIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`${this.basePath}/projects/${projectId}/entities/${entityType}/${entityId}/users/edit`, {
                revokeeIds,
            });
        });
    }
}
exports.EntityPermissionClient = EntityPermissionClient;
//# sourceMappingURL=entity-permissions.client.js.map